import { Flex, ToolIcon } from "@theorgchartdev/storybook";
import BasicChartSearchMenu from "../../Menus/BasicChartSearchMenu/BasicChartSearchMenu";
import AdvancedSearchModal from "./AdvancedSearchModal";
import AgentViewToggle from "../AgentViewToggle/AgentViewToggle";
import React from "react";
import { useChartDocumentContext } from "@/providers/ChartDocumentProvider";
import * as StateLib from "@/Utils/StateLib";
import { appstr } from "@coreapp/utils/appstr";
import { Globals } from "@coreapp/CoreApp/Globals";
import { enumUIModes } from "@coreapp/constants";
import { getToolbarSearchQueryOptions } from "@/hooks/useChartSearch";
import { usePermissionCheck } from "@/hooks/usePermissionCheck";

const CompositeChartSearch = () => {
  let curUIMode = Globals._uiConfig ? Globals._uiConfig.GetUIMode() : enumUIModes.chart;

  const [showAdvancedSearch, setShowAdvancedSearch] = React.useState(false);

  const { canAccessAdvancedSearch } = usePermissionCheck();

  const { chartDocument } = useChartDocumentContext();
  const docNotReady = chartDocument.state === null;

  const openAdvancedSearch = () => {
    setShowAdvancedSearch(true);
  };

  const closeAdvancedSearch = () => {
    setShowAdvancedSearch(false);
  };

  const doc = StateLib.GetDoc();

  const hasAdvancedSearchKeys = doc?.HasSearchKeys() ?? false;

  return (
    <Flex flex={"1"} justifyContent={"center"}>
      <Flex direction={"column"} flex={"1"} gap={"4px"}>
        {doc && (
          <Flex alignItems={"center"} justifyContent={"center"} gap={"12px"}>
            <AgentViewToggle />
            <BasicChartSearchMenu
              id={`toolbar-search-${curUIMode}`}
              dataTestId={`toolbar-search-${curUIMode}-input`}
              getHoldersWithNoPosition={true}
              isPositionChart={doc?.IsPositionDocument()}
              queryOptions={getToolbarSearchQueryOptions(doc)}
              listWidth="fill"
              inputProps={{ autoComplete: "off" }}
            />
            {(docNotReady || hasAdvancedSearchKeys) && canAccessAdvancedSearch && (
              <ToolIcon
                id={"mtb-advsearch-btn"}
                dataTestId={
                  curUIMode === enumUIModes.planning
                    ? "planning-toolbar-advanced-search-btn"
                    : curUIMode === enumUIModes.chart
                      ? "chart-mode-toolbar-advanced-search"
                      : undefined
                }
                name={"sliders"}
                title={"Advanced"}
                onClick={openAdvancedSearch}
                disabled={docNotReady}
                tooltipProps={{ message: appstr("Advanced Search") }}
              />
            )}
          </Flex>
        )}
        <Flex flex={"1"} justifyContent={"center"}>
          {showAdvancedSearch && doc && canAccessAdvancedSearch && (
            <AdvancedSearchModal show={showAdvancedSearch} onClose={closeAdvancedSearch} />
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default CompositeChartSearch;
